import Header from "@/routes/_layout/header"
import Headline from "@/components/headline"
import Wrapper from "@/components/wrapper"
import useIsMobile from "@/hooks/use-is-mobile"
import { langStore } from "@/stores/lang-store"
import { myPageBundle } from "@/routes/my/my-page-const"
import { passwordChangeStore } from "@/routes/my/pw/change/pw-change-store"
import { useEffect } from "react"
import { Outlet } from "react-router-dom"

const MyPageLayout = () => {
  const isMobile = useIsMobile()
  const HeaderComponent = Header.default[isMobile ? "mobile" : "desktop"]
  const { lang } = langStore()

  useEffect(() => {
    return () => passwordChangeStore.getState().reset()
  }, [])

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <HeaderComponent />

      <Wrapper.maxWidth className={"max-w-4xl pt-4"}>
        <Headline
          point={myPageBundle.eyebrow[lang]}
          title={myPageBundle.title[lang]}
          description={myPageBundle.description[lang]}
        />

        <Outlet />
      </Wrapper.maxWidth>
    </main>
  )
}

export default MyPageLayout
